module.exports = __webpack_public_path__ + "img/line5.c7a18357.png";